import isElectron from 'is-electron';

//Offline files
const hour = 3600000; // An hour in milliseconds
const minute = 60000; // A minute in milliseconds
const week = 604800000;

export const REDIRECT_TIMEOUT = 5000;
export const UPDATE_INTERVAL = 1 * hour;
export const RECENT_INTERVAL = 3 * minute;
export const LAST_LOGIN_INTERVAL = 1 * hour;
export const SERVER_REACHABLE_INTERVAL = 7000;
export const TWO_WEEKS = week * 2;

//URLS
export const BackendURL = process.env.REACT_APP_BACKEND_MACHINE;
export const GraphQLURL = BackendURL;
export const LoginURL = GraphQLURL + "/user/login?_format=json";
export const SamlLoginURL = GraphQLURL + "/saml_login?ReturnTo=" + encodeURIComponent ( GraphQLURL + "/saml_frontend_login" );
export const JWTLoginURL = GraphQLURL + "/user/jwt_login";
export const JWTMaskURL = GraphQLURL + "/user/jwt_mask";
export const LogoutURL = GraphQLURL + "/user/logout";
export const LogAccessUrl = GraphQLURL +"/jsonapi/accesslog/accesslog";

//FOLDERS

export const DataFolder = () => {
    if ( isElectron () ) {
        try {
            const electron = window.require ( 'electron' );
            return electron.remote.app.getPath ( 'appData' )
        } catch ( err ) {
            console.error ( "Error getting the Data Folder: " + err );
            return null;
        }
    }
    return null;
};
export const appFolder = populateAppFolder ( DataFolder () );
export const DocumentsFolder = populateDocumentsFolder ( appFolder );
// export const DBFolder = populateDBFolder( appFolder );
// export const DBName = "documents.sqlite";
// export const DBPath = populateDBPath( DBFolder, DBName );
export const LunrIndex = populateLunrIndex ( DocumentsFolder );


//Actions
export const closeNotification = "closeNotification";


function populateAppFolder ( dataFolder ) {
    if ( dataFolder ) {
        return dataFolder + "/werfen-docs-hybrid/";
    }
    return null;
}

function populateDocumentsFolder ( appFolder ) {
    if ( appFolder ) {
        return appFolder + "documents/";
    }
    return null;
}

// function populateDBFolder( appFolder ) {
//     if ( appFolder ) {
//         return appFolder + "databases/";
//     }
//     return null;
// }

// function populateDBPath( DBFolder, DBName ) {
//     if ( DBFolder && DBName ) {
//         return DBFolder + DBName;
//     }
//     return null;
// }

function populateLunrIndex ( DocumentsFolder ) {
    if ( DocumentsFolder ) {
        return DocumentsFolder + "lunrIndex.lnr";
    }
    return null;
}
